// extracted by mini-css-extract-plugin
export default {"root":"Forbidden403_root__UlhfC"};